import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SidebarService } from '../../services/sidebar.service';

export interface SidebarItem {
  label: string;
  route: string;
  icon: string;
  active?: boolean;
  activeIcon?: string;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems: SidebarItem[] = [];
  private readonly subscription = new Subscription();

  constructor(private readonly sidebarService: SidebarService,public readonly router: Router) {}

  ngOnInit(): void {
    
    // Subscribe to sidebar items changes
    this.subscription.add(
      this.sidebarService.sidebarItems$.subscribe(items => {
        this.sidebarItems = items;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
